angular.module('eficienciaFiscalModule')
    .service('authService', ['httpService', 'pathService',
        function (httpService, pathService) {

            var route = pathService.getApiUrl() + "/base/acesso",
                authObj = this.authObj = {},
                authStore = {};

            var addPrivilege = this.addPrivilege = function (resource, privilege, store) {
                var object = store ? (authStore[store] || (authStore[store] = {})) : authObj;
                if (!object[resource]) object[resource] = [];

                if ($.inArray(privilege, object[resource]) == -1)
                    object[resource].push(privilege);
            };

            this.addPrivilegeArray = function(resource, privileges, store) {
                privileges.each(function(privilege){
                    addPrivilege(resource, privilege, store);
                });
            };

            this.authorize = function(callback, store) {
                getPermissions(store ? authStore[store] : authObj, callback)
            };

            var getPermissions = this.getPermissions = function (permissions, callback) {
                httpService.request({
                    method: "POST",
                    url: route,
                    data: permissions,
                    onSuccess: function (data) {
                        callback(data);
                    }
                })

            };

            this.getPermission = function (resource, privilege, callback) {
                httpService.request({
                    method: "PUT",
                    url: route,
                    data: {
                        function: 'checar_permissao',
                        resource: resource,
                        privilege: privilege
                    },
                    onSuccess: function (data) {
                        callback(data);
                    }
                })
            };

            this.getUnidadeCurrent = function (callback, event, loadText) {
                httpService.request({
                    url: route,
                    method: "PUT",
                    blockScreen: true,
                    clickEvent: event,
                    loadingText: loadText,
                    data: {
                        function: 'buscar_unidade_atual'
                    },
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.getCurrentUser = function (callback, event, loadText) {
                return httpService.request({
                    url: route,
                    method: "PUT",
                    blockScreen: true,
                    clickEvent: event,
                    loadingText: loadText,
                    data: {
                        function: 'buscar_entidade'
                    },
                    onSuccess: function (data) {
                        if (callback)
                            callback(data.data);
                    }
                })
            }
        }
    ]);
